import React, { useState } from 'react';
import { ArrowDropDownRounded } from '@mui/icons-material';
import { Button, Collapse, Stack } from '@mui/material';
import { theme } from '../../../theme';
import ReplacementCardEntry from './ReplacementCardEntry';

function ReplacementCardsSection({ cards, selectedIds, onToggleCard, isDisabled }) {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <Stack>
            <Button
                variant='text'
                onClick={() => setIsExpanded((isOpen) => !isOpen)}
                endIcon={<ArrowDropDownRounded sx={{ transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 200ms ease' }} />}
                sx={{ alignSelf: 'flex-start', p: 0, mb: 1, color: theme.palette.subtext.secondary, fontSize: '13px', fontWeight: theme.typography.heavy.fontWeight }}
            >
                This replacement applies to {cards.length} {cards.length === 1 ? 'card' : 'cards'}
            </Button>
            <Collapse in={isExpanded} timeout='auto' unmountOnExit>
                <Stack spacing={1}>
                    {cards.map((card) => (
                        <ReplacementCardEntry
                            key={card.id}
                            card={card}
                            isSelected={selectedIds.includes(card.id)}
                            isDisabled={isDisabled}
                            onToggleSelection={() => onToggleCard(card.id)}
                        />
                    ))}
                </Stack>
            </Collapse>
        </Stack>
    );
}

export default ReplacementCardsSection;